import React from "react";

// Honest accuracy indicator: more illuminated = higher accuracy. null => untested.
export default function MoonPhase({ accuracy = null, size = 26, className = "" }) {
  const id = React.useId();
  const tested = accuracy !== null && accuracy !== undefined;
  const frac = tested ? Math.max(0, Math.min(100, accuracy)) / 100 : 0;
  const r = size / 2;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className={className} role="img"
         aria-label={tested ? `Accuracy ${accuracy}%` : "Not tested"}>
      <defs>
        <clipPath id={`c-${id}`}>
          <circle cx={r} cy={r} r={r - 1} />
        </clipPath>
      </defs>
      <circle cx={r} cy={r} r={r - 1} fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.3)" strokeWidth="1" />
      {tested && (
        <g clipPath={`url(#c-${id})`}>
          <rect x="0" y="0" width={size * frac} height={size} fill="#ffffff" fillOpacity="0.92" />
        </g>
      )}
    </svg>
  );
}
